(function ($) {

    function propertiesSlider() {
        $(".product-property-basic-slider").each(function () {
            var $this = $(this);
            var $slider = $this.find('.swiper-container');
            var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesVisibility: true,
                spaceBetween: 8,
                threshold: 20,
                mousewheel: {
                    forceToAxis: true,
                    thresholdDelta: 20,
                    thresholdTime: 0.1,
                },
                scrollbar: {
                    el: $this.find('.swiper-scrollbar')[0],
                    hide: false,
                    draggable: true,
                },
                navigation: {
                    nextEl: $this.find(".swiper-button-next").get(0),
                    prevEl: $this.find(".swiper-button-prev").get(0),
                },
                breakpoints: {
                    1200: {
                        spaceBetween: 24,
                    },
                },
                on: {
                    reachEnd: function () {
                        this.el.classList.add('-end');
                    },
                    fromEdge: function () {
                        this.el.classList.remove('-end');
                    }
                },
            });
            window.onresize = function () {
                infoSlider.update();
            }
            if ($this.find(".swiper-slide").length === 1) {
                infoSlider.destroy();
            }


            // Funkce zjišťující, zda je obsah širší než wrapper
            function checkOverflow() {
                var totalWidth = 0;
                $slider.find(".swiper-slide").each(function () {
                    totalWidth += $(this).outerWidth(true);
                });

                var containerWidth = $slider.width();

                if (totalWidth < containerWidth) {
                    $slider.addClass("-no-overflow");
                } else {
                    $slider.removeClass("-no-overflow");
                }
            }

            checkOverflow();
            window.onresize = function () {
                checkOverflow();
            }
        });

    }


    $(document).gp_ready(function () {
        propertiesSlider();
    })


    // var w = $(window).width();
    // window.addEventListener('resize', () => {
    //     clearTimeout(window.resizedFinished);
    //     if ($(window).width() === w) return;
    //     w = $(window).width();
    //     window.resizedFinished = setTimeout(function () {
    //         propertiesSlider();
    //     }, 250);
    // });

    var w = $(window).width();
    $( window ).on('resize', function() {
        if ($(window).width()==w) return;
        w = $(window).width();
        propertiesSlider();
    });


})(jQuery);
